import { handleActions, combineActions } from 'redux-actions'
import * as rawActions from '../actions'

export default handleActions(
  {
    [rawActions.getTrackingsRequest](state, action) {
      return true
    },
    [combineActions(rawActions.getTrackingsFailed, rawActions.getTrackingsSuccess)](state, action) {
      return false
    },
    [rawActions.resetTracking]() {
      return false
    },
  },
  false
)
